import { Tabs as AntdTabs } from 'antd'
import CommonButton from '@/components/common/Button'
import styled from '@emotion/styled'

export const Container = styled('div')`
  padding: 32px;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  background-color: white;
`

export const ContainerTitle = styled('div')`
  display: flex;
  justify-content: space-between;
`

export const Title = styled('div')`
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 32px;
`

export const ButtonDocument = styled(CommonButton)``

export const Tabs = styled(AntdTabs)`
  .ant-tabs-tab {
    padding: 0px 0px 14px 0px;
  }

  .ant-tabs-nav {
    margin: 0 0 24px 0;
  }
`

export const ButtonWrapper = styled('div')`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  gap: 16px;
`

